import { Transform } from "class-transformer"

import { PayerCoverageCheckNetwork } from "@common-shared/config/coverage.config"

import { CsvTransform } from "../helpers/csvTransform.helper"

/**
 * One CSV data row for network status rules bulk upload.
 * Header names are mapped to these keys via NETWORK_STATUS_CONFIG.csvHeaderToKey before parsing.
 * Parser trims string values; backend validates required fields, formats, and allowed values.
 * index is set by the parser (row position). name can come from CSV or is set by the parser (default "Import {date} - Rule #N").
 */
export class RawNetworkStatusRuleCsvRowDTO {
    // Set by parser (row position).
    index?: number

    @Transform(({ value }) => CsvTransform.trim(value))
    networkStatus?: PayerCoverageCheckNetwork

    @Transform(({ value }) => CsvTransform.trim(value))
    payerId: string

    @Transform(({ value }) => CsvTransform.trim(value))
    providerNpi: string

    @Transform(({ value }) => CsvTransform.dateToMysqlFormat(value))
    startDate: string

    @Transform(({ value }) => CsvTransform.dateToMysqlFormat(value))
    endDate: string

    @Transform(({ value }) => CsvTransform.toOptionalString(value))
    thirdPartyAdministratorId?: string

    @Transform(({ value }) => CsvTransform.toCommaSeparatedStrings(value))
    insuranceTypes?: string[]

    @Transform(({ value }) => CsvTransform.toCommaSeparatedStrings(value))
    planTypes?: string[]

    @Transform(({ value }) => CsvTransform.toOptionalString(value))
    planName?: string

    @Transform(({ value }) => CsvTransform.toOptionalString(value))
    groupName?: string

    @Transform(({ value }) => CsvTransform.toOptionalString(value))
    state?: string

    @Transform(({ value }) => CsvTransform.toOptionalString(value))
    name?: string
}
